<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('GAME.RONDO.CLASS_MODE.SELECT_TEAM') }}
      </v-card-title>
      <v-card-text>
        <div v-if="teams === 0">
          {{ $t('GAME.CARDS.CLASS_MODE.NO_TEAMS') }}
          <BaseLoader />
        </div>
        <v-row v-else class="mt-4">
          <v-col v-for="i in teams" :key="i">
            <BaseButton
              :color="colorClass(i - 1)"
              @click="selectTeam(i)"
            >
              {{ i }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('BACK') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RondoTeamSelect',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    code: '',
  }),
  computed: {
    teams() {
      const teamCount = this.$store.state.classMode.rondoTeams;
      return teamCount > 0 ? teamCount : 0;
    },
  },
  methods: {
    close() {
      this.$router.push({ name: 'home' });
    },
    selectTeam(team) {
      this.$store.dispatch('classMode/selectTeam', {
        team,
        game: 'rondo',
      });
    },
    startPolling() {
      if (this.polling) {
        return this.polling;
      }

      this.polling = setInterval(() => {
        this.$store.dispatch('classMode/enable', this.$store.state.classMode.session)
          .then(() => {
            if (this.teams > 0) {
              this.stopPolling();
            }
          });
      }, 5000);
      return this.polling;
    },
    stopPolling() {
      clearInterval(this.polling);
      this.polling = null;
    },
  },
  created() {
    if (this.isClassMode && this.teams <= 0) {
      this.startPolling();
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
